import { render, staticRenderFns } from "./oasisMerchant.vue?vue&type=template&id=2ab2978b&scoped=true&"
import script from "./oasisMerchant.vue?vue&type=script&lang=js&"
export * from "./oasisMerchant.vue?vue&type=script&lang=js&"
import style0 from "./oasisMerchant.vue?vue&type=style&index=0&id=2ab2978b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab2978b",
  null
  
)

export default component.exports